/**
 * dealerDate — the dealer's calendar day (IDI-538).
 *
 * New-invoice dates (invoiced date, due-date base) are the dealer's day, not
 * UTC's: a draft made after 7 PM Central is dated today, not tomorrow. The
 * server does the same (cmd/invoices terms.go dealerLocation). America/Chicago
 * until a per-dealer timezone exists.
 *
 * Kept out of formatDate.js on purpose: that module renders instants in the
 * runtime zone and its source guard forbids a forced zone (IDI-259/337).
 */

const DEALER_TIME_ZONE = 'America/Chicago';

/**
 * Today's date in the dealer's zone, as YYYY-MM-DD.
 * @param {Date} [now]
 * @returns {string}
 */
export function dealerToday(now = new Date()) {
  // en-CA formats as YYYY-MM-DD.
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: DEALER_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now);
}
